import { Box } from '@mui/material';

function SubSection({ children, ...props }) {
  return (
    <Box
      style={{
        border: '1px solid #ccc',
        borderRadius: '10px',
        padding: '8px',
      }}
      {...props}>
      {children}
    </Box>
  );
}

export default SubSection;
